export default {
    track: (eventName, properties) =>
        window.heap ? window.heap.track(eventName, properties) : null,
    addEventProperties: obj => (window.heap ? window.heap.addEventProperties(obj) : null),
    removeEventProperty: string => (window.heap ? window.heap.removeEventProperty(string) : null)
};



// WEBPACK FOOTER //
// ./src/modules/heap.js